import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Outputformat } from './outputformat';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutputformatService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Outputformat[]> {
    return this.httpClient.get<Outputformat[]>(this.baseUrl + 'api/OutputformatApi')
  }
  Post(outputformat: Outputformat): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/OutputformatApi/add', outputformat, { headers: header, observe: 'response' })
  }
  Delete(outputformat: Outputformat) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/OutputformatApi/activeordeactive', outputformat, { headers: header, observe: 'response' })
  }
  Put(outputformat: Outputformat): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/OutputformatApi/Update', outputformat, { headers: header, observe: 'response' })
  }
  GetActiveFormats(): Observable<Outputformat[]> {
    return this.httpClient.get<Outputformat[]>(this.baseUrl + 'api/OutputformatApi/GetAllActiveOutputFormast')
  }  

}
